import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StudentsModel } from 'common/models/page-models/student/formmodel/student-data.model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { StudentsFormWidgetService } from 'common/widget/students/students-form-widget.service';
import { data } from 'jquery';




@Injectable({
    providedIn: 'root'
})
export class StudentsFormResolver extends FormResolverService<StudentsModel> {
    constructor(
        protected fs: StudentsFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
        
    }

    //  override modifyResponseData(dataModel: any, meta: any, widget: any) {
    //     dataModel['branch_name']= null;
    // }

    //branch_name
}
